import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConversionEventService {
  private refetchSubject = new Subject<void>();

  refetch$ = this.refetchSubject.asObservable();

  triggerRefetch(): void {
    this.refetchSubject.next();
  }
}
